<div class="all-page-combo-layout">
  <div class="all-page-feed">
    <div class="hpanel">
      <div class="panel-body gs-tm-toolbar border-radius-top-left-right-6">
        <div class="gs-tm-toolbar__title">
          <label class="gs-tm-toolbar__title-label">Members</label>
          <p class="gs-tm-toolbar__title-meta" *ngIf="totalCount === 1">
            {{totalCount}} Member
          </p>
          <p class="gs-tm-toolbar__title-meta" *ngIf="totalCount !== 1">
            {{totalCount || 0}} Members
          </p>
        </div>

        <div class="gs-tm-toolbar__search">
          <ng-icon name="tablerSearch" class="gs-tm-toolbar__search-icon"></ng-icon>
          <input #memberSearchText type="text" class="form-control" placeholder="Search Member"
            name="searchadmin" id="searchadmin" [(ngModel)]="searchKey"
            (input)="onSearchMember(memberSearchText.value)" />
        </div>

        <div class="gs-tm-toolbar__filter">
          <div class="btn-group" dropdown container="body">
            <button id="button-basic" dropdownToggle type="button"
              class="btn btn-primary btn-sm dropdown-toggle"
              aria-controls="dropdown-basic">
              {{filterName}}
              <ng-icon name="tablerFilter"></ng-icon>
            </button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu no-padding" role="menu"
              aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)="allEmployee()">All</a></li>
              <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Admin'" (click)="admins()">Admin</a></li>
              <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Members'" (click)="members()">Members</a></li>
            </ul>
          </div>
        </div>

        <div class="gs-tm-toolbar__add" *ngIf="ownerFlag">
          <button type="button" class="btn primary-btn btn-sm"
            (click)="addmember(AddMemberTemplate)">
            Add Member
          </button>
        </div>
      </div>
    </div>
    <div class="margin-top-5">

      <ng-container *ngIf="loadAPIcall && !loadScroll">
        <div class="col-md-4 padding-left-0 padding-right-5" *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>

      <ng-container *ngIf="(membersData | customFilter:{userName: searchFilterKey}:false) as filtered">
        <div *ngIf="filtered?.length > 0" infiniteScroll [alwaysCallback]="true"
          [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">
          <div class="col-md-4 padding-left-0 padding-right-5 mr-bt-5"
            *ngFor="let data of filtered">
            <app-user-card [userDataInput]="data" [labelName]="'TEAM'"
              (handleEvent)="handleUserCardEvent($event)"
              [config]="userCardConfig" [button]="'PRIMARY'" [standard]="true"></app-user-card>
          </div>

          <ng-container *ngIf="loadScroll">
            <div class="col-md-4 padding-left-0 padding-right-5" *ngFor="let n of [1, 2, 3]">
              <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
            </div>
          </ng-container>
        </div>

        <div class="col-md-12 pad"
          *ngIf="filtered?.length === 0 && searchKey && membersData?.length > 0">
          <app-nodata-found
            screen="SEARCH"
            [title]="['No results found', 'Try adjusting your search']"
            [buttonShow]="false">
          </app-nodata-found>
        </div>
      </ng-container>

      <div class="col-md-12 pad"
        *ngIf="membersData?.length === 0 && !loadAPIcall && membersPayload.searchContent">
        <app-nodata-found
          screen="SEARCH"
          [title]="['No results found', 'Try adjusting your search']"
          [buttonShow]="false">
        </app-nodata-found>
      </div>

      <div class="col-md-12 pad"
        *ngIf="membersData?.length === 0 && !loadAPIcall && !membersPayload.searchContent">
        <app-nodata-found [title]="noDatafound"></app-nodata-found>
      </div>

    </div>
  </div>
  <div class="all-page-widget">
    <app-common-widget [page]="'TEAMS_MEMBER_PAGE'" [inputData]="'TEAM'"></app-common-widget>
  </div>
</div>
<ng-template #AddMemberTemplate>
  <form [formGroup]="membersForm" class="app-form form-horizontal">

    <div class="common-header-flex">
      <div>Add Members</div>
      <button >
        <span (click)="modalRef.hide()" class="common-close">&times;</span>
      </button>
    </div>


    <div class="panel-body app-form">
      <div class="form-group row">
        <div class="col-md-4" style="display: grid;">
          <label for="networkName" class="control-label required-field font-light">Members</label>
        </div>

        <div class="col-md-8">
          <ng-select class="gs-tm-add-select" [items]="conditionList"  [hideSelected]="false" dropdownPosition="bottom"
            appendTo=".gs-add-members-modal"
            formControlName="addconnection" bindLabel="userName" [closeOnSelect]="false" [multiple]="true" placeholder="Add members"
            [(ngModel)]="conditionSelectedItems">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="ng-select-checkbox-label">
                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                <img *ngIf="item.photo" class="img-show-hides" src="{{url+item.photo}}">
                <div *ngIf="!item?.photo">
                  <div  class="circleimg-show-hide" [style.background-color]="getColorName(item?.firstName,item.lastName)">
                    <div class="circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{ getInitialName(item?.firstName,item.lastName) }}</div>
                  </div>
                </div>

                <span class="ng-select-checkbox-text" [attr.title]="item.userName">{{item.userName}}</span>
              </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
              <div class="selected-item" [attr.title]="item.userName">
                <span class="ng-value-clear remove-icon" (click)="clear(item)">
                  ✕
                </span>
                <span class="ng-value-label">{{ item.userName }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>


    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button type="button" class="btn btn-default cancel" (click)="modalRef.hide()">
            Cancel
          </button>
          <button type="button" class="btn primary-btn submit" (click)="submit()">
            Submit
          </button>
        </div>
      </div>
    </div>

  </form>
</ng-template>
